import { Purchases, PAYWALL_RESULT } from '@revenuecat/purchases-capacitor';
import { RevenueCatUI } from '@revenuecat/purchases-capacitor-ui';

// This variable stays outside the object so it's a true "singleton"
let isPaywallPresented = false;

const RevenueCatService = {
    async initialize() {
        try {
            await Purchases.configure({ apiKey: "appl_bGFvvVKZxZvBgudOAaOtdkQavRD" });
        } catch (e) {
            console.error("RC Init Error", e);
        }
    },

    async presentPaywall() {
        // 🛑 PREVENT DUPLICATES: If it's already showing, stop here.
        if (isPaywallPresented) return false;

        try {
            isPaywallPresented = true; // Set the lock
            const { result } = await RevenueCatUI.presentPaywall();
            
            // Unlock when the native UI is dismissed
            isPaywallPresented = false; 

            return result === PAYWALL_RESULT.PURCHASED || result === PAYWALL_RESULT.RESTORED;
        } catch (error) {
            isPaywallPresented = false; // Unlock on error too
            console.error("Paywall Error", error);
            return false;
        }
    }
};

export default RevenueCatService;